import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useAIAgentData } from "../../hooks/useAIAgentData";

// Shared animation variants
const fadeUp = {
  hidden: { opacity: 0, y: 50 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.12 },
  }),
} as const;

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { data } = useAIAgentData();
  const { badgeText, title, faqs } = data.faqSection;

  return (
    <section className="relative px-5 sm:px-10 md:px-16 sm:py-16 py-8">
      <div className="space-y-12">
        <div className="text-center space-y-4">
          <motion.p variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} className="text-[#A6A0F6] text-sm font-medium tracking-widest uppercase">{badgeText}</motion.p>
          <motion.h2 variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={1} className="text-4xl md:text-6xl font-bold text-white">{title}</motion.h2>
        </div>
        <div className="max-w-4xl mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <motion.div key={i} variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} custom={i * 0.4} className="rounded-2xl border border-white/10 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-8 py-6 text-left bg-white/[0.03] hover:bg-white/[0.06] transition-colors"
              >
                <span className="text-xl text-white font-medium pr-4">{faq.q}</span>
                <span className="text-[#1179F9] flex-shrink-0">{openIndex === i ? <ChevronUp size={20} /> : <ChevronDown size={20} />}</span>
              </button>
              <AnimatePresence initial={false}>
                {openIndex === i && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.25, ease: "easeInOut" }}
                    className="overflow-hidden"
                  >
                    <div className="px-8 py-4 text-xl text-[#d9d9d9] leading-relaxed bg-white/[0.02]">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
